export default {"src":"/_next/static/media/No Results.ddd08854.svg","height":732,"width":894,"blurWidth":0,"blurHeight":0};